import { render } from "./AssociationThirtyYear.vue?vue&type=template&id=7c36c5e6"
import script from "./AssociationThirtyYear.vue?vue&type=script&lang=js"
export * from "./AssociationThirtyYear.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__